const pronouns = [
  {
    caption: '...',
    value: '',
  },
  {
    caption: 'He/Him',
    value: '0',
  },
  {
    caption: 'She/Her',
    value: '1',
  },
  {
    caption: 'They/Them',
    value: '3',
  },
  {
    caption: 'Other',
    value: '2',
  },
  // {
  //   caption: "Something else; I'll tell my Coach when we chat!",
  //   value: '3',
  // },
];
const coachGenders = [
  {
    caption: '...',
    value: '',
  },
  {
    caption: 'Male',
    value: 'Male',
  },
  {
    caption: 'Female',
    value: 'Female',
  },
  {
    caption: 'No Preference',
    value: 'No Preference',
  },
];

const oneToFiveScale = [
  {
    caption: '...',
    value: null,
  },
  {
    caption: '1',
    value: 1,
  },
  {
    caption: '2',
    value: 2,
  },
  {
    caption: '3',
    value: 3,
  },
  {
    caption: '4',
    value: 4,
  },
  {
    caption: '5',
    value: 5,
  },
];

const unitPreferences = [
  {
    caption: '...',
    value: null,
  },
  {
    caption: 'Imperial (feet, inches, lbs)',
    value: '0',
  },
  {
    caption: 'Metric (meters, kilograms)',
    value: '1',
  },
];

const onboardingQuestionMap = {
  pronouns,
  unitPreferences,
  coachGenders,
  oneToFiveScale,
};

export default onboardingQuestionMap;
